<template>
  <div :class="classes()"><slot /></div>
</template>

<script>
export default {
  name: 'Row',
  props: {
    verticalCenter: Boolean,
    marginBottom: Boolean,
  },
  data() {
    return {
      el: 'c-row',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--verticalCenter`]: this.verticalCenter,
          [`${el}--marginBottom`]: this.marginBottom,
        };
      },
    };
  },
};
</script>
